import { render, staticRenderFns } from "./ScaleSidebarMenu.vue?vue&type=template&id=f20b755a&scoped=true&"
import script from "./ScaleSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./ScaleSidebarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20b755a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f20b755a')) {
      api.createRecord('f20b755a', component.options)
    } else {
      api.reload('f20b755a', component.options)
    }
    module.hot.accept("./ScaleSidebarMenu.vue?vue&type=template&id=f20b755a&scoped=true&", function () {
      api.rerender('f20b755a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/ScaleSidebarMenu.vue"
export default component.exports